import {reactFetchJSON, type JSONRequestInit} from '@github-ui/verified-fetch'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import type {BulkActionQueryTarget} from '@github-ui/item-picker-base/ItemPicker'
import {UpdateIssuesBulk, UpdateIssuesBulkByQuery} from '@github-ui/server-persisted-queries'
import type {UpdateIssuesBulkMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulk'
import type {UpdateIssuesBulkByQueryMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulkByQuery'

export type UpdateIssueAssigneesBulkRequest = {
  ids: string[]
  queryTarget?: BulkActionQueryTarget
  applyAssigneeIds?: string[]
  removeAssigneeIds?: string[]
}

export type UpdateIssueAssigneesBulkResponse = GraphQLResponse<
  Partial<UpdateIssuesBulkMutation & UpdateIssuesBulkByQueryMutation>
>

export async function apiUpdateIssueAssigneesBulk(
  request: UpdateIssueAssigneesBulkRequest,
): Promise<UpdateIssueAssigneesBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const body: Record<string, unknown> = {
    ...(request.queryTarget ?? {ids: request.ids}),
    queryId: request.queryTarget ? UpdateIssuesBulkByQuery : UpdateIssuesBulk,
  }

  if (request.applyAssigneeIds && request.applyAssigneeIds.length > 0) {
    body['applyAssigneeIds'] = request.applyAssigneeIds
  }

  if (request.removeAssigneeIds && request.removeAssigneeIds.length > 0) {
    body['removeAssigneeIds'] = request.removeAssigneeIds
  }

  const init: JSONRequestInit = {
    method: 'POST',
    body,
  }
  const response = await reactFetchJSON(requestUrl, init)
  return response.json() as Promise<UpdateIssueAssigneesBulkResponse>
}
